/* TSC quick add (31 Oct 2026). The small + on product cards in collection grids and homepage rows.
   Loaded once from sections/tsc-portrait-images.liquid (header group, every page).
   - Adds a + to every .grid-product card that is not sold out.
   - Colour cards (one card per colour, ?variant= in the card link): + adds that colour in one tap.
     If that colour also comes in sizes (capsule pieces, robe): a small panel opens with the sizes.
   - Cards without a colour: one option adds at once; 2 to 8 options open the panel;
     more than 8 (mix-and-match bundles) go to the product page.
   - Skips gift cards, "Add a gift box" and products tagged no-quick-add.
   - After adding: the theme's cart drawer opens (where the cart add-on and free bonnet bar live). */
(function () {
  if (window.__tscQuickAdd) return;
  window.__tscQuickAdd = true;

  var css = [
    '.grid-product__content{position:relative}',
    '.quick-product__btn{display:none!important}',
    '.tsc-qa-wrap{position:absolute;top:0;left:0;right:0;aspect-ratio:4/5;pointer-events:none;z-index:3}',
    '.tsc-qa{pointer-events:auto;position:absolute;right:10px;bottom:10px;width:36px;height:36px;padding:0;border-radius:50%;',
    'display:flex;align-items:center;justify-content:center;background:rgba(255,255,255,.94);border:1px solid #E3DCCF;color:#2F2F2F;cursor:pointer;',
    'transition:background .2s ease,color .2s ease,border-color .2s ease;-webkit-tap-highlight-color:transparent}',
    '.tsc-qa::after{content:"";position:absolute;inset:-5px;border-radius:50%}',
    '.tsc-qa svg{width:16px;height:16px;fill:none;stroke:currentColor;stroke-width:1.2}',
    '.tsc-qa .tsc-qa__tick{display:none}',
    '.tsc-qa.is-added .tsc-qa__plus{display:none}.tsc-qa.is-added .tsc-qa__tick{display:block}',
    '.tsc-qa.is-added,.tsc-qa:focus-visible{background:#2F2F2F;color:#fff;border-color:#2F2F2F}',
    '@media (hover:hover){.tsc-qa:hover{background:#2F2F2F;color:#fff;border-color:#2F2F2F}}',
    '.tsc-qa.is-busy{opacity:.55;pointer-events:none}',
    '@media (max-width:768px){.tsc-qa{right:8px;bottom:8px;width:34px;height:34px}}',
    '.tsc-qas{border:0;padding:0;margin:auto;width:min(420px,100vw);max-width:100vw;background:#fff;color:#2F2F2F}',
    '.tsc-qas::backdrop{background:rgba(47,47,47,.4)}',
    '.tsc-qas__in{position:relative;padding:28px 24px 24px;font-family:"Tenor Sans",sans-serif;text-align:left}',
    '.tsc-qas__x{position:absolute;top:6px;right:6px;width:44px;height:44px;background:none;border:0;cursor:pointer;color:#2F2F2F;display:flex;align-items:center;justify-content:center}',
    '.tsc-qas__x svg{width:18px;height:18px;fill:none;stroke:currentColor;stroke-width:1}',
    '.tsc-qas__eyebrow{margin:0 0 6px;font-size:11px;letter-spacing:.2em;text-transform:uppercase;color:#6B655E}',
    '.tsc-qas__title{margin:0 44px 18px 0;font-family:"Cormorant Garamond","Cormorant",Georgia,serif;font-weight:400;font-size:24px;line-height:1.2;text-transform:none;letter-spacing:0;text-align:left}',
    '.tsc-qas__opts{display:flex;flex-wrap:wrap;gap:8px}',
    '.tsc-qas__opt{min-width:56px;min-height:46px;padding:0 16px;background:#fff;border:1px solid #C9C2B4;color:#2F2F2F;cursor:pointer;font-family:"Tenor Sans",sans-serif;font-size:13px;letter-spacing:.06em}',
    '.tsc-qas__opt:hover,.tsc-qas__opt:focus-visible{border-color:#2F2F2F;background:#FAF8F5}',
    '.tsc-qas__opt.is-busy{opacity:.55;pointer-events:none}',
    '.tsc-qas__opt small{display:block;font-size:11px;color:#6B655E;letter-spacing:0;margin-top:2px}',
    '.tsc-qas__more{display:inline-block;margin-top:18px;font-size:11px;letter-spacing:.16em;text-transform:uppercase;color:#2F2F2F;text-decoration:underline;text-underline-offset:4px}',
    '.tsc-qas__err{margin:12px 0 0;font-size:12px;color:#3C3C3C}',
    '@media (max-width:749px){.tsc-qas{margin:auto 0 0;width:100vw}.tsc-qas__in{padding:26px 16px calc(22px + env(safe-area-inset-bottom))}}'
  ].join('');
  var st = document.createElement('style');
  st.textContent = css;
  document.head.appendChild(st);

  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var ICON = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path class="tsc-qa__plus" d="M12 5v14M5 12h14"/><path class="tsc-qa__tick" d="M5.5 12.5l4.2 4.2 8.8-9.4"/></svg>';
  var cache = {};

  function cardInfo(card) {
    var handle = card.getAttribute('data-product-handle');
    var link = card.querySelector('a.grid-product__link, a[href*="/products/"]');
    var href = link ? link.getAttribute('href') : '';
    var m = href && href.match(/[?&]variant=(\d+)/);
    var titleEl = card.querySelector('.grid-product__title');
    return { handle: handle, href: href || (root + 'products/' + handle), variantId: m ? parseInt(m[1], 10) : null, title: titleEl ? titleEl.textContent.trim() : '' };
  }

  function decorate(scope) {
    (scope || document).querySelectorAll('.grid-product').forEach(function (card) {
      if (card.__tscQa) return;
      card.__tscQa = true;
      var handle = card.getAttribute('data-product-handle');
      if (!handle || /gift-card|add-a-gift-box/.test(handle)) return;
      if (card.querySelector('.grid-product__tag--sold-out')) return;
      var content = card.querySelector('.grid-product__content');
      if (!content) return;
      var info = cardInfo(card);
      var wrap = document.createElement('div');
      wrap.className = 'tsc-qa-wrap';
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'tsc-qa';
      b.setAttribute('aria-label', 'Add ' + (info.title || 'to cart') + ' to cart');
      b.innerHTML = ICON;
      wrap.appendChild(b);
      content.appendChild(wrap);
    });
  }

  function getProduct(handle) {
    if (!cache[handle]) {
      cache[handle] = fetch(root + 'products/' + handle + '.js', { headers: { Accept: 'application/json' } }).then(function (r) {
        if (!r.ok) throw new Error('product');
        return r.json();
      });
      cache[handle].catch(function () { delete cache[handle]; });
    }
    return cache[handle];
  }

  function money(cents) {
    var v = cents / 100;
    return '£' + (v % 1 === 0 ? v.toFixed(0) : v.toFixed(2));
  }

  function updateCounts() {
    fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
      document.querySelectorAll('[data-cart-count], .cart-link__bubble-num, .cart-count').forEach(function (el) { el.textContent = cart.item_count; });
      document.querySelectorAll('.cart-link__bubble').forEach(function (el) { el.classList.toggle('cart-link__bubble--visible', cart.item_count > 0); });
    }).catch(function () {});
  }

  function openDrawer(item, btn) {
    try { document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: item, addToCartBtn: btn } })); } catch (e) {}
    setTimeout(function () {
      if (document.querySelector('.drawer--is-open')) return;
      var t = document.querySelector('.js-drawer-open-cart, a.site-header__cart, [data-drawer-toggle="cart"]');
      if (t) { t.click(); } else { window.location.href = root + 'cart'; }
    }, 450);
  }

  function add(id, btn, done) {
    btn.classList.add('is-busy');
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
    }).then(function (r) {
      return r.json().then(function (j) { if (!r.ok) throw j; return j; });
    }).then(function (j) {
      btn.classList.remove('is-busy');
      if (done) done(true);
      updateCounts();
      openDrawer(j.items ? j.items[0] : j, btn);
    }).catch(function (err) {
      btn.classList.remove('is-busy');
      if (done) done(false, err);
    });
  }

  function flashAdded(btn) {
    btn.classList.add('is-added');
    setTimeout(function () { btn.classList.remove('is-added'); }, 1600);
  }

  var sheet;
  function getSheet() {
    if (sheet) return sheet;
    sheet = document.createElement('dialog');
    sheet.className = 'tsc-qas';
    sheet.setAttribute('aria-labelledby', 'tsc-qas-t');
    sheet.innerHTML = '<div class="tsc-qas__in">' +
      '<button type="button" class="tsc-qas__x" aria-label="Close"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 5l14 14M19 5L5 19"/></svg></button>' +
      '<p class="tsc-qas__eyebrow">Choose your size</p>' +
      '<h2 class="tsc-qas__title" id="tsc-qas-t"></h2>' +
      '<div class="tsc-qas__opts"></div>' +
      '<p class="tsc-qas__err" hidden></p>' +
      '<a class="tsc-qas__more" href="#">View details</a></div>';
    sheet.addEventListener('click', function (e) { if (e.target === sheet) sheet.close(); });
    sheet.querySelector('.tsc-qas__x').addEventListener('click', function () { sheet.close(); });
    document.body.appendChild(sheet);
    return sheet;
  }

  function openSheet(btn, title, href, opts, eyebrow) {
    var s = getSheet();
    if (!s.showModal) { window.location.href = href; return; }
    s.querySelector('.tsc-qas__eyebrow').textContent = eyebrow;
    s.querySelector('.tsc-qas__title').textContent = title;
    s.querySelector('.tsc-qas__more').setAttribute('href', href);
    var err = s.querySelector('.tsc-qas__err');
    err.hidden = true;
    var wrap = s.querySelector('.tsc-qas__opts');
    wrap.innerHTML = '';
    var prices = {};
    opts.forEach(function (o) { prices[o.price] = 1; });
    var showPrice = Object.keys(prices).length > 1;
    opts.forEach(function (o) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'tsc-qas__opt';
      b.textContent = o.label;
      if (showPrice) { var sm = document.createElement('small'); sm.textContent = money(o.price); b.appendChild(sm); }
      b.addEventListener('click', function () {
        add(o.id, b, function (ok, e) {
          if (ok) { s.close(); flashAdded(btn); }
          else { err.textContent = (e && e.description) || 'Sorry, that did not add. Please try again.'; err.hidden = false; }
        });
      });
      wrap.appendChild(b);
    });
    s.showModal();
  }

  function optionNames(p) {
    return (p.options || []).map(function (o) { return (typeof o === 'string' ? o : o.name) || ''; });
  }

  function handleTap(btn) {
    var card = btn.closest('.grid-product');
    var info = cardInfo(card);
    btn.classList.add('is-busy');
    getProduct(info.handle).then(function (p) {
      btn.classList.remove('is-busy');
      if ((p.tags || []).indexOf('no-quick-add') !== -1) { window.location.href = info.href; return; }
      var names = optionNames(p);
      var colIdx = -1;
      names.forEach(function (n, i) { if (/^colou?r$/i.test(n)) colIdx = i; });
      var picked = info.variantId ? p.variants.filter(function (v) { return v.id === info.variantId; })[0] : null;
      var list = p.variants.filter(function (v) {
        if (!v.available) return false;
        if (picked && colIdx >= 0) return v.options[colIdx] === picked.options[colIdx];
        return true;
      });
      if (!list.length) { window.location.href = info.href; return; }
      if (list.length === 1) {
        add(list[0].id, btn, function (ok) { if (ok) flashAdded(btn); else window.location.href = info.href; });
        return;
      }
      if (list.length > 8) { window.location.href = info.href; return; }
      var others = names.map(function (n, i) { return i; }).filter(function (i) { return !(picked && i === colIdx); });
      var opts = list.map(function (v) {
        var label = others.map(function (i) { return v.options[i]; }).join(' / ');
        return { id: v.id, label: label || v.title, price: v.price };
      });
      var onlySize = others.length === 1 && /size/i.test(names[others[0]]);
      var title = p.title + (picked && colIdx >= 0 ? ', ' + picked.options[colIdx] : '');
      openSheet(btn, title, info.href, opts, onlySize ? 'Choose your size' : 'Choose your option');
    }).catch(function () {
      btn.classList.remove('is-busy');
      window.location.href = info.href;
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('button.tsc-qa');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    handleTap(btn);
  }, true);

  /* warm the product data on first touch or hover, so the tap feels instant */
  ['pointerenter', 'touchstart'].forEach(function (ev) {
    document.addEventListener(ev, function (e) {
      var btn = e.target.closest && e.target.closest('.tsc-qa');
      if (!btn) return;
      var card = btn.closest('.grid-product');
      if (card) getProduct(card.getAttribute('data-product-handle')).catch(function () {});
    }, { passive: true, capture: true });
  });

  function start() {
    decorate(document);
    if ('MutationObserver' in window) {
      new MutationObserver(function (muts) {
        muts.forEach(function (m) {
          m.addedNodes.forEach(function (n) { if (n.nodeType === 1) decorate(n.parentNode || n); });
        });
      }).observe(document.body, { childList: true, subtree: true });
    }
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', start); } else { start(); }
})();
